module.exports = __webpack_public_path__ + "assets/img/criancas3.bb8b47d7.jpg";